module.exports = __webpack_public_path__ + "static/reindeer-front-7de8daae5883fef34f46ce745c83f1f1.png";